module.exports = __webpack_public_path__ + "img/16.f4f4e037.jpg";